// @ts-nocheck

export type TicketGetWithTicketComments = typeof TicketGetWithTicketComments[keyof typeof TicketGetWithTicketComments];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TicketGetWithTicketComments = {
  true: 'true',
  false: 'false',
} as const;
